import React from "react";
import ManageUserSection from "src/components/Users/Add/ManageUserSection";

const Add = () => {
  return <ManageUserSection />;
};

export default Add;
